import React, { useEffect, useState } from 'react';
import { DropDown } from '../../../components/common';
import { ToggleButton, CustomInput } from '../../../components/common';
import Modal from '../../../components/common/modal';
import { useUpdateListenerProfile } from '../../../hooks/useUsers';
import { PeerType } from '../../../hooks/usePeers';
import { Avatar } from '../../../components/ui';
import { getListenerProfileUrl } from '../../listener-reviewers/common/listener-review-constants';

export type CardProps = {
  currentPhotoUrl: any;
  proposedPhotoUrl: string;
  firstName: string;
  lastName: string;
  comms: any;
  profilePicVerified: boolean;
  peerState: string;
  listenerId: number;
  userId?: number;
};

const ProfileStatusOptions = [
  { label: 'Needs Review', value: 'review' },
  { label: 'Approve', value: 'approve' },
  { label: 'Reject', value: 'reject' },
];

const ProfileGradeCard: React.FunctionComponent<CardProps> = ({
  currentPhotoUrl,
  proposedPhotoUrl,
  firstName,
  lastName,
  comms,
  profilePicVerified,
  peerState,
  listenerId,
  userId,
}): JSX.Element => {
  const [ProfileStatus, setProfileStatus] = useState('review');
  const [SendEmail, setSendEmail] = useState(comms?.length > 0 && comms[0]?.id);
  const [RejectModeldata, setRejectModeldata] = useState<any>();
  const [messagePopUp, setmessagePopUp] = useState(false);
  const { mutate: updateListenerProfile } = useUpdateListenerProfile();

  useEffect(() => {
    if (SendEmail && comms) {
      const message = comms.find((item: any) => item.id === SendEmail);
      setRejectModeldata({ ...message, send_message: true });
    } else if (comms) {
      setRejectModeldata({ ...comms[0], send_message: true });
    }
  }, [SendEmail, comms]);

  const submitAvatarGrade = () => {
    const payload =
      ProfileStatus === 'reject'
        ? {
            system_message_id: RejectModeldata.id,
            send_message: RejectModeldata.send_message,
            message: RejectModeldata.message,
            subject: RejectModeldata.subject,
          }
        : undefined;

    updateListenerProfile({ listenerId, type: ProfileStatus, payload: payload });
    setmessagePopUp(false);
  };

  const determineProfileCSS = (): string => {
    if ([PeerType.ONBOARDING_PEER, PeerType.REJECTED_PEER, PeerType.ACTIVE_PEER].includes(peerState)) {
      return 'border-gray-dark';
    } else if (peerState === PeerType.UPGRADING_PEER) {
      return 'upgrade-border';
    } else {
      return 'border-blue-primary';
    }
  };

  return (
    <>
      <Modal
        isModel={messagePopUp}
        InnerComponent={
          <div className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <div className="my-2 w-full">
                    <CustomInput
                      inputType={'text'}
                      value={RejectModeldata?.subject}
                      setValue={(data) => {
                        setRejectModeldata((prev: any) => ({
                          ...prev,

                          subject: data,
                        }));
                      }}
                      Label={'Subject'}
                      labelClass={'block text-sm leading-4   text-blue-dark mb-2'}
                      dataTestId="reject-message-subject"
                    />
                  </div>

                  <h3 className="text-blue-dark mb-2 block text-sm leading-4" id="modal-title">
                    Body
                  </h3>

                  <div className="my-2 w-full">
                    <textarea
                      className="text-gray-dark bg-gray-background-light h-28 w-full rounded-md px-3 py-2 text-sm font-extrabold leading-4 focus:outline-none"
                      value={RejectModeldata?.message}
                      onChange={(evt) => {
                        setRejectModeldata((prev: any) => ({
                          ...prev,

                          message: evt.target.value,
                        }));
                      }}
                      data-testid="reject-message-profile-grade-card-body"
                    />
                  </div>

                  <div className="w-1/2">
                    <div className="flex items-center justify-between">
                      <label className="text-blue-dark mb-2 block text-sm leading-4"> Send Message </label>

                      <ToggleButton
                        id={'Send Message'}
                        status={RejectModeldata?.send_message}
                        setStatus={(data) => {
                          setRejectModeldata((prev: any) => ({
                            ...prev,

                            send_message: data,
                          }));
                        }}
                        initialstatus={true}
                      ></ToggleButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                data-testid="send-message-button"
                type="button"
                onClick={submitAvatarGrade}
                className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
              >
                SEND MESSAGE
              </button>

              <button
                data-testid="close-message-button"
                type="button"
                onClick={() => {
                  setmessagePopUp(false);
                }}
                className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
              >
                CLOSE
              </button>
            </div>
          </div>
        }
      />

      <div
        className={'flex h-48 w-full rounded bg-white px-7 ' + (profilePicVerified && proposedPhotoUrl ? 'mb-10' : '')}
      >
        {currentPhotoUrl && (
          <div className="flex flex-col p-3">
            <Avatar variant="rounder" image={currentPhotoUrl} className="cursor-pointer" />
            <div className="flex justify-center">Current</div>
          </div>
        )}
        {proposedPhotoUrl && (
          <div className="flex flex-col p-3">
            <Avatar variant="rounder" image={proposedPhotoUrl} className="cursor-pointer" />
            <div className="flex justify-center">Proposed</div>
          </div>
        )}

        <div className="w-full py-4 pl-4">
          {/* We're only sending userId from the avatar review page, so that we don't link to the listener profile page from that page */}
          <a
            href={userId ? getListenerProfileUrl(listenerId, userId) : undefined}
            target="_blank"
            rel="noopener noreferrer"
            className={`blue-primary py-1 text-2xl font-normal ${userId ? 'cursor-pointer' : ''}`}
            onClick={(e) => {
              if (!userId) {
                e.preventDefault();
              }
            }}
          >
            {`${firstName} ${lastName}`}
          </a>
          {proposedPhotoUrl && (
            <div className="flex justify-between gap-x-2">
              <div className="w-1/2">
                <DropDown
                  Label={'Profile Status'}
                  value={ProfileStatus}
                  setValue={setProfileStatus}
                  labelClass={' text-sm leading-4   text-blue-dark '}
                >
                  {ProfileStatusOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </DropDown>
              </div>

              <div className="w-1/2">
                {ProfileStatus === 'reject' && (
                  <DropDown
                    data-testid="send-email-dropdown"
                    Label={'Send Email'}
                    value={SendEmail}
                    setValue={setSendEmail}
                    labelClass={' text-sm leading-4  text-blue-dark '}
                  >
                    {comms?.length > 0 &&
                      comms.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </DropDown>
                )}
              </div>
            </div>
          )}
          {ProfileStatus !== 'review' && proposedPhotoUrl && (
            <button
              data-testid="save-and-notify-button"
              className="bg-blue-primary my-3 rounded-full px-4 py-2 text-center text-sm text-white"
              onClick={() => {
                ProfileStatus === 'reject' ? setmessagePopUp(true) : submitAvatarGrade();
              }}
            >
              Save and notify
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileGradeCard;
